import * as actionTypes from "./actionTypes";
import SarafanApiClient from "../../services/SarafanApiClient";

const AnalyticsErrors = {
  fetchEventsFailed: 'Не удалось обновить список событий.',
  editEventFailed: 'Не удалось сохранить данные события.'
}

export const editEvent = (editedEvent, successCallback, errorCallback) => {
  return (dispatch) => {
    const eventData = {
      id: editedEvent.id,
      internal_description: editedEvent.internal_description || null,
    }

    SarafanApiClient.analyticsEdit(eventData)
      .then((response) => {
        if (response &&
          typeof(response.body) === 'object' &&
          response.body.is_successful &&
          typeof(response.body.data) === 'object') {

          dispatch({
            type: actionTypes.UPDATE_EVENT,
            event: response.body.data,
          })
          successCallback()
        } else {
          errorCallback(AnalyticsErrors.editEventFailed)
        }

      })
      .catch((error) => {
        errorCallback(AnalyticsErrors.editEventFailed)
      })
  }
}

export const fetchEvents = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.EVENTS_REQUESTED
    })

    SarafanApiClient.analyticsList()
      .then((response) => {
        if (response &&
          typeof(response.body) === 'object' &&
          Array.isArray(response.body.data))
        {
          dispatch({
            type: actionTypes.EVENTS_SUCCEED,
            events: response.body.data,
          })
        } else {
          dispatch({
            type: actionTypes.EVENTS_FAIL,
            error: AnalyticsErrors.fetchEventsFailed
          })
        }

      })
      .catch((error) => {
        dispatch({
          type: actionTypes.EVENTS_FAIL,
          error: AnalyticsErrors.fetchEventsFailed
        })
      })
  }
}

export const fetchClientFunnel = (successCallback, errorCallback) => {
    return (dispatch) => {
        SarafanApiClient.clientFunnel()
            .then((response) => {
                if (response &&
                    typeof(response.body) === 'object' &&
                    Array.isArray(response.body.data))
                {
                    successCallback(response.body.data)
                } else {
                    errorCallback(AnalyticsErrors.fetchEventsFailed)
                }

            })
            .catch((error) => {
                errorCallback(AnalyticsErrors.fetchEventsFailed)
            })
    }
}

export const fetchProFunnel = (successCallback, errorCallback) => {
    return (dispatch) => {
        SarafanApiClient.proFunnel()
            .then((response) => {
                if (response &&
                    typeof(response.body) === 'object' &&
                    Array.isArray(response.body.data))
                {
                    successCallback(response.body.data)
                } else {
                    errorCallback(AnalyticsErrors.fetchEventsFailed)
                }

            })
            .catch((error) => {
                errorCallback(AnalyticsErrors.fetchEventsFailed)
            })
    }
}

export const fetchTopProLinks = (successCallback, errorCallback) => {
    return (dispatch) => {
        SarafanApiClient.topProLinks()
            .then((response) => {
                if (response &&
                    typeof(response.body) === 'object' &&
                    Array.isArray(response.body.data))
                {
                    successCallback(response.body.data)
                } else {
                    errorCallback(AnalyticsErrors.fetchEventsFailed)
                }

            })
            .catch((error) => {
                errorCallback(AnalyticsErrors.fetchEventsFailed)
            })
    }
}

export const fetchStatistic = (successCallback, errorCallback) => {
    return (dispatch) => {
        SarafanApiClient.statistic()
            .then((response) => {
                if (response &&
                    typeof(response.body) === 'object' &&
                    typeof(response.body.data) === 'object')
                {
                    successCallback(response.body.data)
                } else {
                    errorCallback(AnalyticsErrors.fetchEventsFailed)
                }

            })
            .catch((error) => {
                errorCallback(AnalyticsErrors.fetchEventsFailed)
            })
    }
}



// WEBPACK FOOTER //
// ./src/redux/analytics/actions.js